<template>
    <v-app id="login" class="pf-signup-form">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center class="flex-column">
            <!-- <v-flex xs12 sm8 md6 class="mb-5">
              <v-card class="pf-box-shadow-3 border-radius-10 pt-4 px-3 pb-3">
                <v-card-text class="pb-0">
                  <div class="layout column align-center pb-4">
                    <img src="/static/login_logo.png" alt="Parent Finder">
                  </div>
                  <p class="pf-font-13 text-xs-center">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Explicabo in, impedit quod dicta est facilis consectetur laborum eius vitae voluptate asperiores, vel ipsa laboriosam odit esse beatae nesciunt architecto deserunt.</p>
                </v-card-text>
              </v-card>
            </v-flex> -->
            <v-flex xs12 sm8 md6 class="pf-width-100p">
              <v-card class="pf-signup-box border-radius-15 py-5 my-4 px-4">
                <div v-if="agencyLogo" class="layout column align-center mt-3 pb-4">
                  <img width="200" :src="agencyLogo" alt="Organization Logo">
                </div>
                <div v-else class="layout column align-center mt-3 pb-4">
                  <img src="/static/login_logo.png" alt="Parent Finder">
                </div>
                <template v-if="page === 1">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm1">
                      <!-- Organization -->
                      <v-layout class="flex-column mb-5">
                        <h3 class="pf-signup-head mb-3">Membership Information</h3>
                        <p class="my-3 mb-4 signup-hint-text">A few lines of introduction text will be here. A few lines of introduction text will be here. A few lines of introduction text will be here.</p>
                        <v-flex v-if="agenciesBackup.length">
                          <label v-if="!agencyMatched" class="join-input-label">Choose Organization</label>
                          <v-autocomplete
                            label="Enter Organization Name"
                            item-text="name"
                            :search-input.sync="search"
                            item-value="_id"
                            v-if="!agencyMatched"
                            clearable
                            :items="agencies"
                            @change="organizationChanged"
                            single-line solo
                            v-model="agency">
                          </v-autocomplete>
                          <span v-else class="flex-center pf-text-teal pf-font-20 font-weight-bold mt-3">
                            {{ agencies.find(x => x._id.toString() === agency.toString()).name }}
                          </span>
                        </v-flex>
                        
                        <template v-if="!agency">
                          <v-layout class="flex-center my-4">
                            <v-flex class="line"></v-flex>
                            <v-flex class="flex-no-grow mx-3 mb-2">OR</v-flex>
                            <v-flex class="line"></v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <!-- <v-flex xs12 class="pf-error-alert flex-row">
                              <v-icon size="17" class="red--text mr-2">warning</v-icon>
                              <span class="error-text">We couldn't find the organization you searched for, <b>Add New</b></span>
                            </v-flex> -->
                            <v-flex sm6>
                              <label class="mx-2 join-input-label">Contact Name</label>
                              <v-text-field 
                                label="Contact name"
                                type="text"
                                v-model.trim="contact.name"
                                v-on:keyup.enter="{}"
                                class="px-2"
                               single-line solo></v-text-field>
                            </v-flex>
                            <v-flex sm6>
                              <label class="mx-2 join-input-label">Phone Number</label>
                              <v-text-field 
                                v-mask="'(###) ###-####'"
                                label="Contact phone number"
                                placeholder="(###) ###-####"
                                v-model.trim="contact.phone" 
                                @input="{}"
                                class="px-2"
                               single-line solo></v-text-field>
                            </v-flex>
                          </v-layout>
                        </template>
                      </v-layout>
  
                      <!-- Membership -->
                      <v-layout v-if="agency && memberships.length === 1" class="flex-column mb-5">
                        <span class="flex-center pf-font-18 mt-3">Membership Amount: <b class="ml-2 pf-text-green">{{ formatPrice(memberships[0].recurring_amount) }}</b></span>
                      </v-layout>
                      <v-layout class="flex-column mb-5" v-else-if="memberships.length > 1 && (agency || (contact.name && contact.phone))">
                        <label class="join-input-label">Choose Membership</label>
                        <v-layout class="flex-column">
                          <v-flex @click="user.membership = membership.name" :class="{ 'mb-3': m !== memberships.length - 1, 'pf-border-green-1': membership.name === user.membership, 'grey lighten-4': membership.name !== user.membership }" class="flex-space-between cursor-pointer pa-3 border-radius-20" v-for="(membership, m) in memberships" :key="m">
                            <v-flex class="flex-row">
                              <v-radio-group v-model="user.membership" class="flex-grow-0" :rules="[v => !!v || '']">
                                <v-radio color="black" :value="membership.name"></v-radio>
                              </v-radio-group>
                              <v-flex class="flex-column">
                                <span class="membership-text">{{ membership.name }}</span>
                                <span class="membership-price">$ {{ membership.recurring_amount }}</span>
                              </v-flex>
                            </v-flex>
                            <v-flex class="flex-end">
                              <v-btn class="membership-btn" @click.stop="membershipView = membership.name">Details</v-btn>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" :disabled="!agency && (!this.contact.name || !this.contact.phone)" @click="goNext" :loading="loading">Continue</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </template>

                <template v-else-if="page === 2">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm2">
                      <!-- Account information -->
                      <v-layout class="flex-column mb-4">
                        <h3 class="pf-signup-head mb-3">Account Information</h3>
                        <p class="mt-3 signup-hint-text">{{ confidentialityText }} </p>
                        <v-flex class="pf-border-lighter-1 border-radius-15 px-4 mt-3 mb-4">
                          <v-radio-group v-model="user.type" row :rules="[v => !!v || 'Choose your account type']">
                            <template v-slot:label>
                              <label class="join-input-label b-0 mx-2">Choose Account Type:</label>
                            </template>
                            <v-radio label="Single" color="#040900" value="Single" :selected="user.type === 'Single'"></v-radio>
                            <v-radio label="Couple" color="#040900" value="Couple" :selected="user.type === 'Couple'"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <h3 v-if="user.type === 'Couple'" class="pf-signup-subhead my-2 px-2 mb-5">Person 1</h3>
                        <v-layout wrap>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">First Name:</label>
                            <v-text-field label="First name" v-model.trim="user.firstname1" class="px-2" @input="{}" :rules="[v => !!v || 'Enter the firstname']" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Last Name:</label>
                            <v-text-field label="Last name" v-model.trim="user.lastname1" class="px-2" @input="{}" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Gender:</label>
                            <v-select @change="{}" v-model="user.gender1" :items="genders" label="Gender" class="px-2" single-line solo></v-select>
                          </v-flex>
                        </v-layout>
                        <!-- <v-radio-group v-model="user.address.default" class="px-2 mt-0">
                          <v-radio 
                            label="Set as default contact" 
                            @change="{}" 
                            value="Parent 1"
                            color="teal">
                          </v-radio>                        
                        </v-radio-group> -->
                      </v-layout>
                      <v-layout class="flex-column mb-3" v-if="user.type === 'Couple'">
                        <h3 class="pf-signup-subhead my-2 px-2 mb-5">Person 2</h3>
                        <v-layout wrap>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">First Name:</label>
                            <v-text-field label="First name" v-model.trim="user.firstname2" class="px-2" :rules="[v => !!v || 'Enter the firstname']" @input="{}" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Last Name:</label>
                            <v-text-field label="Last name" v-model.trim="user.lastname2" class="px-2" @input="{}" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Gender:</label>
                            <v-select @change="{}" v-model="user.gender2" :items="genders" label="Gender" class="px-2" single-line solo></v-select>
                          </v-flex>
                        </v-layout>
                      </v-layout>

                      <template v-if="user.type === 'Couple'">
                        <!-- Line -->
                        <v-flex class="mt-3 mb-5 horizontal-line-green-1"></v-flex>
                        <!-- Relationship -->
                        <v-layout wrap>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Relationship:</label>
                            <v-select @change="{}" v-model="user.relation" :items="relationships" label="Relationship" class="px-2" single-line solo></v-select>
                          </v-flex>
                        </v-layout>
                      </template>  
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext" :loading="loading">Continue</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </template>

                <template v-else-if="page === 3">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm3">
                      <!-- Username -->
                      <v-layout class="flex-column mb-4">
                        <h3 class="pf-signup-head mb-3">Create Username</h3>
                        <p class="my-4 signup-hint-text">{{ confidentialityText }} </p>
                        <v-layout wrap>
                          <v-flex xs12>
                            <label class="join-input-label mx-2">Username:</label>
                            <v-text-field label="Enter preffered username" v-model.trim="user.username" class="px-2" @change="duplicateUserNameChecking" :rules="[v => !!v || 'Enter the username']" hint="Username should be unique" single-line solo>
                              <template v-slot:append>
                                <v-icon size="20" v-if="isUsernameVerified" class="green--text mr-2">check_circle</v-icon>
                                <v-icon size="20" v-else class="red--text mr-2">cancel</v-icon>
                              </template>
                          </v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Password:</label>
                            <v-text-field 
                              height="40"
                              :type="showPassword ? 'text' : 'password'"
                              browser-autocomplete="new-password"
                              name="password" 
                              label="Password"
                              v-model.trim="user.password"
                              class="px-2"
                              v-on:keyup.enter="{}"
                              @focus="isPasswordFocused = true"
                              @blur="isPasswordFocused = false"
                              :rules="passwordRules"
                              single-line solo
                            >
                              <template v-slot:append>
                                <span class="input-show-hide" icon @click="showPassword = !showPassword">
                                  {{ showPassword ? 'Hide' : 'Show' }}
                                </span>
                              </template>
                            </v-text-field>
                            <!-- Password rules -->
                            <v-layout class="mx-2 pf-info-alert" v-if="isPasswordFocused" style="width: 100%" :class="{ 'pf-width-100p': $vuetify.breakpoint.smAndDown }">
                              <v-flex class="flex-column">
                                <v-flex class="flex-row">
                                  <span class="pf-text-dark font-weight-medium">Password must have,</span>
                                </v-flex>
                                <ul class="my-2">
                                  <li>
                                    8 characters minimum
                                    <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': user.password.length >= 8 }">{{ 8 > user.password.length ? 'cancel' : 'check_circle'}}</v-icon>
                                  </li>
                                  <li>
                                    An uppercase letter
                                    <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': /[A-Z]/.test(user.password) }">{{ /[A-Z]/.test(user.password) ? 'check_circle' : 'cancel' }}</v-icon>
                                  </li>
                                  <li>
                                    At least 1 numeric character
                                    <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': /\d/.test(user.password) }">{{ /\d/.test(user.password) ? 'check_circle' : 'cancel' }}</v-icon>
                                  </li>
                                </ul>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Confirm Password:</label>
                            <v-text-field 
                              height="40"
                              :type="showPassword2 ? 'text' : 'password'"
                              browser-autocomplete="new-password"
                              name="password" 
                              label="Confirm Password"
                              v-model.trim="user.confirmPassword"
                              v-on:keyup.enter="{}"
                              class="px-2"
                              :rules="confirmPasswordRules"
                              single-line solo
                            >
                              <template v-slot:append>
                                <span class="input-show-hide" icon @click="showPassword2 = !showPassword2">
                                  {{ showPassword2 ? 'Hide' : 'Show' }}
                                </span>
                              </template>
                            </v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Email:</label>
                            <v-text-field label="Email Address" v-model.trim="user.email" class="px-2" :rules="emailRules" hint="Email should be unique" @change="duplicateEmailChecking" single-line solo>
                              <!-- <template v-slot:append>
                                <v-icon v-if="isEmailVerified" size="20" class="green--text mr-2">check_circle</v-icon>
                                <span class="input-show-hide" icon @click="verifyEmail()" v-else>
                                  {{ 'Verify' }}
                                </span>
                              </template> -->
                            </v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Mobile:</label>
                            <v-text-field v-mask="'(###) ###-####'" label="Mobile Number" placeholder="(###) ###-####" v-model.trim="user.phone" @input="{}" class="px-2" :rules="phoneRules" single-line solo>
                              <!-- <template v-slot:append>
                                <v-icon size="20" v-if="isPhoneVerified" class="green--text mr-2">check_circle</v-icon>
                                <span v-else class="input-show-hide" icon @click="verifyPhone()">
                                  {{ 'Verify' }}
                                </span>
                              </template> -->
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext" :loading="loading">Continue</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </template>

                <template v-else-if="page === 4">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm4">
                      <!-- Username -->
                      <v-layout class="flex-column mb-4">
                        <h3 class="pf-signup-head mb-3" v-if="!isCodeSent">Email Verification</h3>
                        <h3 class="pf-signup-head mb-3" v-else>Verification Code</h3>
                        <p class="mt-3 signup-hint-text" v-if="!isCodeSent">We'll send you an email with a verification code. If the email doesn't show up soon, check your spam folder. The code will expire in 15 minutes.</p>
                        <p v-else class="mt-3 mb-4 signup-hint-text">Enter the 6 digit verification code  that we sent to your email address.</p>
                        <v-layout wrap v-if="isCodeSent" class="my-4">
                          <div class="otp-container">
                            <input type="text" autofocus maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit1" @input="focusNext($event)" />
                            <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit2" @input="focusNext($event)" />
                            <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit3" @input="focusNext($event)" />
                            <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit4" @input="focusNext($event)" />
                            <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit5" @input="focusNext($event)" />
                            <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit6" @input="focusNext($event)" />
                          </div>
                        </v-layout>
                        <v-layout v-else>
                          <v-flex class="flex-center">
                            <v-icon size="140" class="pf-signup-green-text mr-2">{{ isEmailVerified ? 'check_circle' : 'outgoing_mail' }}</v-icon>
                          </v-flex>
                        </v-layout>
                        <p class="mt-3 signup-hint-text pf-text-green" v-if="isEmailVerified">Your email address was verified.</p>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" v-if="isCodeSent" :disabled="this.otp.length !== 6" @click="submitOTP">Verify Code</v-btn>
                    <v-btn v-else-if="!isEmailVerified" class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="sendCode">Continue</v-btn>
                    <v-btn v-else class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext">Continue</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <v-layout>
                    <v-flex class="flex-center my-4" v-if="isCodeSent && ((isVerifyEmail && !isEmailVerified) || (isVerifyPhone && !isPhoneVerified))">
                      <span>Didn't receive? <a :disabled="canResendCode" class="pf-auth-link" :class="{ 'disabled': !canResendCode }" @click="sendCode($event, true)">Resend code</a><span v-if="!canResendCode && timer"> in {{ timer }} seconds</span></span>
                    </v-flex>
                  </v-layout>
                </template>

                <template v-else-if="page === 5">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm5">
                      <!-- Address -->
                      <v-layout class="flex-column mb-4">
                        <h3 class="pf-signup-head mb-3">Address Information</h3>
                        <p class="mt-3 mb-4 signup-hint-text">{{ confidentialityText }} </p>
                        <v-layout wrap>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Street:</label>
                            <v-text-field label="Street address" v-model.trim="user.address.line_1" class="px-2" @input="{}" :rules="[v => !!v || 'Enter your address']" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Zip:</label>
                            <v-text-field 
                              label="Zip Code" 
                              v-model="user.address.zip" 
                              class="px-2"
                              v-mask="'#####'"
                              :rules="zipRules"
                              single-line solo
                              @change="lookupAddress">
                            </v-text-field>
                          </v-flex>
                          <!-- <v-flex sm6>
                            <v-text-field label="Street Address Line 2" v-model="user.address.line_2" @input="{}" class="px-2" single-line solo></v-text-field>
                          </v-flex> -->
                          <v-flex class="xs12 sm6 full">
                            <label class="join-input-label mx-2">City:</label>
                            <v-autocomplete
                              v-if="user.address.country === '5f0af2eb1b61360afbb1aa0c' && cityData.length"
                              label="City"
                              :items="cityData"
                              class="px-2" 
                              :readonly="cityData.length === 1"
                              :rules="[v => !!v || 'Select the city']"
                              v-model="user.address.city"
                              single-line solo
                              ></v-autocomplete>
                            <v-text-field v-else label="City" class="px-2" v-model.trim="user.address.city" @input="{}" :rules="[v => !!v || 'Enter the city']" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex class="xs12 sm6">
                            <label class="join-input-label mx-2">State:</label>
                            <v-autocomplete
                              label="State" 
                              :items="filteredStates" 
                              item-value="id"
                              item-text="name"
                              :no-data-text="stateDropdownText"
                              class="px-2" 
                              @change="{}" 
                              :rules="[v => !!v || 'Select the state']"
                              single-line solo
                              v-model="user.address.state">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex class="xs12 sm6">
                            <label class="join-input-label mx-2">Country:</label>
                            <v-autocomplete
                              label="Country" 
                              class="px-2"
                              item-text="name"
                              item-value="id"
                              :items="Country" 
                              :rules="[v => !!v || 'Select the country']"
                              v-model="user.address.country"
                              single-line solo
                              @change="{}">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <v-checkbox
                              v-model="agreed"
                              color="#90C073"
                              :rules="[v => !!v || 'Please agree the terms & conditions']"
                              class="px-3">
                              <template v-slot:label>
                                <span>By continuing, you agree to the <a class="pf-auth-link" target="_blank" :href="`${config.host}privacy-policy`">Terms and Conditions</a></span>
                              </template>
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext" :loading="loading">{{ paymentDoneBy === 'agency' ? 'Register' : 'Continue'}}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </template>
                <!-- Payment -->
                <template v-else-if="page === 6">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm6">
                      <!-- Address -->
                      <v-layout class="flex-column flex-center mb-4">
                        <h3 class="pf-signup-head mb-3">Payment Information</h3>
                        <v-layout class="flex-center grey pf-width-50p amount-div white--text mt-4 mb-5 border-radius-10" v-if="user.membership">
                          <span class="flex-center pf-font-24">Amount: {{ formatPrice(memberships[memberships.findIndex(x => x.name === user.membership)].recurring_amount) }}</span>
                        </v-layout>
                        <!-- <v-layout>
                          <credit-card @update="updateCardFields"></credit-card>
                        </v-layout> -->
                        <v-layout wrap>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Card Number:</label>
                            <v-text-field label="Enter card number" v-model.trim="card.cardNumber" v-mask="generateCardNumberMask" class="px-2" :rules="[v => !!v || 'Enter card number']" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <label class="join-input-label mx-2">Name on the Card:</label>
                            <v-text-field label="Enter name on the card" v-model.trim="card.cardName" class="px-2" :rules="[v => !!v || 'Enter the name']" single-line solo></v-text-field>
                          </v-flex>
                          <v-flex sm4>
                            <label class="join-input-label mx-2">Month:</label>
                            <v-select @change="{}" v-model="card.cardMonth" :items="['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']" label="Select month" class="px-2" :rules="[v => !!v || 'Select the month']" single-line solo>
                              <template v-slot:item="{ item }">
                                <v-list-tile-content :disabled="parseInt(item, 10) < minCardMonth">
                                  <v-list-tile-title>{{ item }}</v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </v-select>
                          </v-flex>
                          <v-flex sm4>
                            <label class="join-input-label mx-2">Year:</label>
                            <v-select @change="{}" v-model="card.cardYear" :items="next12Years" label="Select year" class="px-2" :rules="[v => !!v || 'Select the year']" single-line solo></v-select>
                          </v-flex>
                          <v-flex sm4>
                            <label class="join-input-label mx-2">CVV:</label>
                            <v-text-field @change="{}" v-mask="'####'" v-model="card.cardCvv" :rules="[v => !!v || 'Enter card CVV']" :items="genders" label="Enter CVV" class="px-2" single-line solo></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext" :disabled="!isCardDetailsEntered" :loading="loading">Pay & Register</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </template>

                <!-- Summary -->
                <template v-else-if="page === 7">
                  <v-card-text class="pb-0">
                    <v-layout class="pf-error-alert" v-if="longError">
                      <v-flex class="flex-row">
                        <v-icon size="17" class="red--text mr-2">warning</v-icon>
                        <span class="error-text">{{ longError }}</span>
                      </v-flex>
                    </v-layout>
                    <v-form ref="joinForm7">
                      <!-- Username -->
                      <v-layout class="flex-column mb-4">
                        <h3 class="pf-signup-head mb-3">Order Confirmation</h3>
                        <v-layout class="flex-column">
                          <v-flex class="flex-center mt-2">
                            <v-icon size="140" class="pf-signup-green-text mr-2">verified</v-icon>
                          </v-flex>
                          <v-layout class="flex-column my-5">
                            <v-flex>
                              <v-layout class="flex-row flex-top py-3" wrap>
                                <v-flex class="order-label" xs6>
                                  <span>Billing Address</span>
                                </v-flex>
                                <v-flex class="order-detail flex-column">
                                  <span>{{ user.firstname1 }}{{ user.lastname1 ? ' ' + user.lastname1 : '' }}</span>
                                  <span>{{ user.address.line_1 }}</span>
                                  <span v-if="user.address.line_2">{{ user.address.line_2 }}</span>
                                  <span>{{ user.address.city }} {{ getStateText }} {{ user.address.zip }}</span>
                                </v-flex>
                              </v-layout>
                              <v-flex class="my-3 horizontal-line-green-1"></v-flex>
                            </v-flex>
                            <v-flex>
                              <v-layout class="flex-row flex-top py-3" wrap>
                                <v-flex class="order-label" xs6>
                                  <span>Payment Method</span>
                                </v-flex>
                                <v-flex class="order-detail flex-column">
                                  <span>{{ getCardType }}</span>
                                </v-flex>
                              </v-layout>
                              <v-flex class="my-3 horizontal-line-green-1"></v-flex>
                            </v-flex>
                            <v-flex>
                              <v-layout class="flex-row flex-top py-3" wrap>
                                <v-flex class="order-label" xs6>
                                  <span>Order Summary</span>
                                </v-flex>
                                <v-flex class="order-detail flex-column">
                                  <span>{{ user.membership }} Membership</span>
                                  <span class="order-price">Total: $ {{ memberships[memberships.findIndex(x => x.name === user.membership)].recurring_amount }}</span>
                                </v-flex>
                              </v-layout>
                              <v-flex class="my-3 horizontal-line-green-1"></v-flex>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="pf-btn login-btn signup-back-btn box-shadow-none" @click="goBack">Back</v-btn>
                    <v-btn class="pf-btn login-btn signup-continue-btn box-shadow-none" @click="goNext">Checkout</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <v-layout>
                    <v-flex class="flex-center my-4" v-if="isCodeSent && ((isVerifyEmail && !isEmailVerified) || (isVerifyPhone && !isPhoneVerified))">
                      <span>Didn't receive? <a :disabled="canResendCode" class="pf-auth-link" :class="{ 'disabled': !canResendCode }" @click="sendCode($event, true)">Resend code</a><span v-if="!canResendCode && timer"> in {{ timer }} seconds</span></span>
                    </v-flex>
                  </v-layout>
                </template>

                <v-flex class="flex-row mx-3 mt-3" v-if="error">
                  <v-icon size="17" class="red--text mr-2">warning</v-icon>
                  <span class="red--text font-weight-bold">{{ error }}</span>
                </v-flex>

                <!-- <v-flex class="flex-space-between mt-5 mb-3 mx-4" v-if="!$route.params.agencyId">
                  <a class="pf-text-dark font-weight-bold" :href="config.host">Home</a>
                  <span class="pf-text-dark font-weight-bold cursor-pointer" @click="backToLogin">Back to Login</span>
                  <a class="pf-text-dark font-weight-bold" target="_blank" :href="config.helpForm">Need Help?</a>
                </v-flex> -->

              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <app-modal :active="!!membershipView && !!membershipDetails[membershipView]" v-if="!!membershipView && !!membershipDetails[membershipView]" :width="$vuetify.breakpoint.smAndDown ? `100%` : '60%'">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="membershipView = null">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ membershipView }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-4 mb-4">
              <v-flex class="flex-center flex-column my-2">
                <p class="mt-3 signup-hint-text">
                  {{ membershipDetails[membershipView] }}
                </p>
              </v-flex>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="membershipView = null"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
    </v-app>
  </template>
<script>
/* global session, $t store config */
import { getCollection, request, guestLogin, isEmailValid, isPhoneValid, formatPrice } from '../helpers/helpers';
import { sha512 } from 'js-sha512';
import { mask } from 'vue-the-mask';
import CreditCard from './widgets/CreditCard';
import swal from 'sweetalert2';
import AppModal from '../components/AppModal';

export default
{
  directives: { mask },
  components: {
    'credit-card': CreditCard,
    'app-modal': AppModal
  },
  beforeRouteEnter (to, from, next) {
    if (session.isOnline()) {
      let role = session.getSession().user.role;
      let homePage = (role === 'admin' ? '/admin/dashboard' : (['agency', 'caseworker'].indexOf(role) > -1 ? '/agency/dashboard' : (role === 'parent' ? '/dashboard' : '/dashboard')));
      next({ path: homePage });
    } else {
      if (to.query.requestFrom && to.query.requestFrom === 'invalid' && (to.name !== 'Login' || config.host.indexOf('localhost') === -1)) {
        session.logout();
      } else {
        next();
      }
    }
  },
  data: (_v) => ({
    config,
    formatPrice,
    loading: false,
    page: 1,
    error: '',
    longError: '',
    showPassword: false,
    showPassword2: false,
    stateDropdownText: '',
    genders: ['Male', 'Female', 'Female to Male', 'Male to Female', 'In Transition', 'Other', 'Unknown'],
    relationships: ['Partner', 'Spouse', 'Co-Habbitant'],
    generalMemberships: [],
    memberships: [
      {
        'name': 'Network',
        'amount': '300',
        'recurring_amount': '250'
      },
      {
        'name': 'Featured',
        'amount': '750',
        'recurring_amount': '700'
      },
      {
        'name': 'Preferred',
        'amount': '2000',
        'recurring_amount': '1800'
      }
    ],
    confidentialityText: `The data you enter below will be kept Confidential & Secured. It will only be available to your agency and Parentfinder support staff.`,
    membershipDetails: {
      Network: 'Network membership is for those who are looking to connect with other families and professionals in the adoption community. This membership includes access to the Parentfinder community, the ability to search for other families and professionals, and the ability to message other members.',
      Featured: 'Featured membership is for those who are looking to connect with other families and professionals in the adoption community. This membership includes access to the Parentfinder community, the ability to search for other families and professionals, the ability to message other members, and the ability to post a profile.',
      Preferred: 'Preferred membership is for those who are looking to connect with other families and professionals in the adoption community. This membership includes access to the Parentfinder community, the ability to search for other families and professionals, the ability to message other members, the ability to post a profile, and the ability to post a blog.'
    },
    membershipView: null,
    search: null,
    user: {
      type: 'Couple',
      membership: '',
      firstname1: '',
      lastname1: '',
      firstname2: '',
      lastname2: '',
      phone: '',
      email: '',
      gender1: '',
      gender2: '',
      relation: '',
      username: '',
      password: '',
      confirmPassword: '',
      address: {
        line_1: '',
        line_2: '',
        zip: '',
        state: '',
        country: '',
        default: 'Parent 1'
      }
    },
    card: {
      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: ''
    },
    paymentData: null,
    agency: '',
    contact: {
      name: '',
      phone: ''
    },
    agreed: false,
    isUsernameVerified: false,
    isEmailExistsVerified: false,
    isEmailVerified: false,
    isCodeSent: false,
    otp: '',
    verificationId: null,
    isPhoneVerified: false,
    cityData: [],
    isVerifyEmail: false,
    isVerifyPhone: false,
    paymentDoneBy: 'family',
    agencies: [],
    agenciesBackup: [],
    passwordRules: [
      v => !!v || 'Enter the password',
      v => !!v && v.length >= 8 || 'Password is not valid',
      v => /(?=.*?[A-Z])/.test(v) || 'Password is not valid',
      v => /(?=.*?[0-9])/.test(v) || 'Password is not valid'
    ],
    isPasswordFocused: false,
    confirmPasswordRules: [
      v => !!v || 'Please re-enter the password',
      v => v === _v.user.password || 'Password should be match with new password',
    ],
    emailRules: [
      (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address'
    ],
    phoneRules: [
      v => !!v || 'Please enter your phone number',
      (v) => /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
    ],
    zipRules: [
      v => !!v || 'Please enter the zip code',
      (v) => /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
    ],
    timer: null,
    interval: null,
    canResendCode: false,
    OTPError: null,
    agencyMatched: false,
    agencyLogo: '',
    minCardYear: new Date().getFullYear(),
    amexCardMask: '#### ###### #####',
    otherCardMask: '#### #### #### ####'
  }),
  computed: {
    filteredStates () {
      this.stateDropdownText = this.user.address.country ? 'No data available' : 'Please select country';
      let options = this.State;
      return options.filter(o => o.country.id === this.user.address.country);
    },
    getStateText () {
      return this.State.find(o => o._id.toString() === this.user.address.state).name;
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    },
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    isCardDetailsEntered () {
      return this.card.cardNumber && this.card.cardName && this.card.cardMonth && this.card.cardYear && this.card.cardCvv && this.card.cardCvv.length > 2;
    },
    getCardType () {
      let number = this.card.cardNumber;
      let re = new RegExp('^4');
      if (number.match(re) != null) return 'Visa';

      re = new RegExp('^(34|37)');
      if (number.match(re) != null) return 'Amex';

      re = new RegExp('^5[1-5]');
      if (number.match(re) != null) return 'Mastercard';

      re = new RegExp('^6011');
      if (number.match(re) != null) return 'Discover';
      
      re = new RegExp('^9792');
      if (number.match(re) != null) return 'Troy';

      return 'None'; // default type
    },
    generateCardNumberMask () {
      return this.getCardType === 'amex' ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth () {
      if (this.card.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
    next12Years () {
      const currentYear = new Date().getFullYear();
      const next12Years = [];
      for (let i = 0; i < 12; i++) {
        next12Years.push(currentYear + i);
      }
      return next12Years;
    }
  },
  watch: {
    search (val) {
      if (val && val.length > 2) {
        this.setAgencyList();
      } else {
        this.agencies = [];
      }
    }
  },
  async created () {
    window.getApp.$emit('BGProgress', false);
    this.agency = this.$route.params.agencyId || this.agency;
    await this.fetchAgencies();
    if (this.agency) {
      const agency = this.agencies.find(x => x._id.toString() === this.agency.toString());
      if (agency) {
        this.setAgencyList();
        this.agencyMatched = true;
        /* Agency logo */
        if (agency.avatar && agency.avatar !== '') {
          this.agencyLogo = agency.avatar;
        } else {
          this.agencyLogo = '';
        }
        if (agency.account_settings && agency.account_settings.paymentDoneBy) {
          this.paymentDoneBy = agency.account_settings.paymentDoneBy;
        }
        if (agency.memberships && agency.memberships.length) {
          this.setMemberships(agency.memberships);
        }
      } else {
        this.agency = null;
      }
    }
    this.initializeCountry();
    this.initializeState();
  },
  methods: {
    setAgencyList () {
      this.agencies = this.agenciesBackup;
    },
    setMemberships (memberships = []) {
      if (memberships && memberships.length) {
        this.memberships = memberships.sort((a, b) => {
          return parseInt(a.amount, 10) - parseInt(b.amount, 10);
        });
        this.memberships = memberships.filter(x => {
          return typeof x.enabled === 'undefined' || x.enabled;
        }).map(x => {
          if (!x.recurring_amount) {
            x.recurring_amount = x.amount;
          }
          return x;
        });
      }
    },
    async fetchAgencies () {
      if (!this.agenciesBackup.length) {
        window.getApp.$emit('LoadingText', 'Fetching organization details');
        let { error, data } = await getCollection('Agency/Public', true);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load agency list'
          };
        } else {
          if (data.length) {
            this.agenciesBackup = data.filter(x => !x.is_admin);
            const admin = data.find(x => x.is_super_admin);
            if (admin) {
              this.setMemberships(admin.memberships || this.memberships);
              this.generalMemberships = this.memberships;
            }
          }
        }
      }
    },
    async initializeCountry () {
      if (!this.Country.length) {
        window.getApp.$emit('LoadingText', 'Fetching data');
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        window.getApp.$emit('LoadingText', 'Fetching data');
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
    organizationChanged () {
      this.agencyLogo = '';
      if (this.agency) {
        const agency = this.agencies.find(x => x.id.toString() === this.agency.toString());
        if (agency) {
          /* Agency logo */
          if (agency.avatar && agency.avatar !== '') {
            this.agencyLogo = agency.avatar;
          } else {
            this.agencyLogo = '';
          }
          this.agencyData = agency;
          if (agency.memberships && agency.memberships.length) {
            this.setMemberships(agency.memberships);
          } else {
            this.setMemberships(this.generalMemberships);
          }
          if (agency.account_settings && agency.account_settings.paymentDoneBy) {
            this.paymentDoneBy = agency.account_settings.paymentDoneBy;
          } else {
            this.paymentDoneBy = 'family';
            this.user.membership = '';
          }
        }
      } else {
        this.setMemberships(this.generalMemberships);
      }
    },
    backToLogin (gotoLogin = true) {
      this.page = 1;
      this.error = '';
      this.longError = '';
      this.memberships = [
        {
          'name': 'Network',
          'amount': '300',
          'recurring_amount': '250'
        },
        {
          'name': 'Featured',
          'amount': '750',
          'recurring_amount': '700'
        },
        {
          'name': 'Preferred',
          'amount': '2000',
          'recurring_amount': '1800'
        }
      ];
      this.user = {
        type: 'Couple',
        membership: '',
        firstname1: '',
        lastname1: '',
        firstname2: '',
        lastname2: '',
        phone: '',
        email: '',
        gender1: '',
        gender2: '',
        relation: '',
        username: '',
        password: '',
        confirmPassword: '',
        address: {
          line_1: '',
          line_2: '',
          zip: '',
          state: '',
          country: '',
          default: 'Parent 1'
        }
      };
      this.card = {
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      };
      this.paymentData = null;
      this.agency = '';
      this.contact = {
        name: '',
        phone: ''
      };
      this.cancelVerification();
      this.stopInterval();
      this.timer = null;
      this.interval = null;
      this.canResendCode = false;
      this.OTPError = null;
      if (gotoLogin) {
        /* Clear the guest token */
        store.commit('setGuestToken', null);
        this.store.commit('resetStates');
        global.localStorage.setItem(sha512('PF_session_data'), '0');
        global.localStorage.setItem(sha512('PF_session_id'), false);
        this.$router.push('/login');
      }
    },
    updateCardFields (field, value) {
      if (typeof field !== 'undefined' && typeof value !== 'undefined') {
        this.card[field] = value;
      }
    },
    goBack () {
      this.longError = '';
      this.error = '';
      if (this.page > 1) {
        this.page = this.page - 1;
      } else if (this.page === 1) {
        /* Login back to browser history */
        this.backToLogin(false);
        window.history.back();
      }
    },
    async goNext ($event, emailVerify = false) {
      this.longError = '';
      this.error = '';
      let isPaymentDone = false;
      if (emailVerify || this.$refs[`joinForm${this.page}`].validate()) {
        /* Check if email verified */
        if (this.page === 4) {
          /* if (!this.isPhoneVerified && this.user.phone) {
            this.longError = 'Please verify your phone number';
            return false;
          } */
          if (!this.isEmailVerified) {
            this.longError = 'Please verify your email address';
            return false;
          }
        } else if (this.page === 3) {
          /* Enable email verification */
          this.isVerifyEmail = true;
        }
        if (this.page === 7 || (this.page === 5 && this.paymentDoneBy === 'agency')) {
          if (await guestLogin()) {
            if (this.paymentDoneBy !== 'agency') {
              window.getApp.$emit('LoadingText', 'Please wait, We\'re processing the payment');
              let { error, data } = await this.processPayment();
              this.paymentData = data;
              if (error) {
                console.log(error);
                this.longError = error || 'Failed to process the payment, please try again';
                return false;
              } else {
                isPaymentDone = true;
              }
            } else {
              isPaymentDone = true;
            }
            if (isPaymentDone) {
              window.getApp.$emit('LoadingText', 'Creating your profile');
              let { error: registerError, data: registerData } = await this.registerUser();
              if (registerError) {
                console.log(registerError);
                this.longError = registerError || 'Failed to process the request, please try again';
              } else {
                swal.fire({
                  type: 'success',
                  title: 'Your account has been created. You can login now',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: async () => {
                    this.backToLogin();
                  }
                });
              }
            }  
          } else {
            this.longError = 'Failed to process your request, please try again';
          }
        } else if (this.page < 8) { // not last page
          this.page += 1;
        }
      } else {
        this.longError = this.page === 1 ? 'Please choose a membership type' : 'Please correct the errors and try again';
      }
    },
    async processPayment () {
      try {
        /* Create the payment mode without the account id */
        const membership = this.memberships.find(x => x.name === this.user.membership);
        if (membership) {
          let paymentPayload = {
            agency: this.agency,
            basic_details: {
              parent1: {
                first_name: this.user.firstname1,
                last_name: this.user.lastname
              },
              username: this.user.username,
              membership: this.user.membership,
              phone: this.user.phone,
              email: this.user.email
            },
            address: {
              line_1: this.user.address.line_1,
              line_2: this.user.address.line_2,
              city: this.user.address.city,
              state: this.user.address.state,
              zip: this.user.address.zip,
              country: this.user.address.country
            },
            card: {
              number: this.card.cardNumber.replace(/\s/g, ''),
              name: this.card.cardName,
              expiry: this.card.cardMonth.toString() + this.card.cardYear.toString().slice(2)
            },
            amount: parseInt(membership.amount, 10),
            recurring_amount: parseInt(membership.recurring_amount, 10),
            customer_ip: ''
          };
      
          if (this.user.type === 'Couple') {
            paymentPayload.basic_details.parent2 = {
              first_name: this.user.firstname2,
              last_name: this.user.lastname2
            };
          }
          /* Process the payment */
          let { error, data } = await request('Payment/Signup', 'POST', paymentPayload, null, null, true);
          return { error, data };
        }
      } catch (e) {
        return { error: e };
      }
    },
    async registerUser () {
      try {
        if (this.paymentData || this.paymentDoneBy === 'agency') {
          /* Register the user */
          let registerPayload = {
            account_type: this.user.type,
            first_name: this.user.firstname1,
            last_name: this.user.lastname1,
            gender: this.user.gender1 || 'Unknown',
            username: this.user.username,
            password: this.user.password,
            membership: this.user.membership,
            contactInfo: {
              line_1: this.user.address.line_1,
              line_2: this.user.address.line_2,
              city: this.user.address.city,
              state: this.user.address.state,
              zip: this.user.address.zip,
              country: this.user.address.country,
              phone: this.user.phone,
              email: this.user.email
            }
          };
          if (this.agency) {
            registerPayload.agency = [{
              agency: this.agency,
              status: 'Pending'
            }];
          } else {
            registerPayload.contact = this.contact;
          }
          if (this.paymentDoneBy !== 'agency') {
            registerPayload.payment_data = this.paymentData;
          }
          if (this.user.type === 'Couple') {
            registerPayload.first_name2 = this.user.firstname2;
            registerPayload.last_name2 = this.user.lastname2;
            registerPayload.gender2 = this.user.gender2 || 'Unknown';
            registerPayload.relation = this.user.relation;
          }
          /* Process the request */
          let { error, data } = await request('Account/Register', 'POST', registerPayload, null, null, true);
          return { error, data };
        } else {
          return { error: 'No payment data found' };
        }
      } catch (e) {
        return { error: e };
      }
    },
    async duplicateUserNameChecking () {
      this.isUsernameVerified = false;
      this.longError = '';
      this.error = '';
      if (this.user.username.length && await guestLogin()) {
        window.getApp.$emit('LoadingText', 'Checking username availability');
        const usernameUrl = `User/UsernameCheck/${this.user.username}`;
        const response = await request(usernameUrl, 'GET', {}, null, null, true);
        if (response.error) {
          console.log(response.error);
          this.longError = response.error === 'Username exists' ? 'The username already exists' : response.error;
          this.user.username = '';
        } else {
          this.isUsernameVerified = true;
        }
      }
    },
    async duplicateEmailChecking () {
      /* Need to re-verify */
      this.isEmailVerified = false;
      this.isEmailExistsVerified = false;
      this.longError = '';
      this.error = '';
      if (this.user.email && isEmailValid(this.user.email) && await guestLogin()) {
        const emailUrl = `User/EmailCheck/${this.user.email}`;
        let { error, data } = await request(emailUrl, 'GET', {}, null, null, true);
        if (error) {
          console.log(error);
          this.longError = error === 'Email address exists' ? 'The email already exists' : error;
          this.user.email = '';
        } else {
          this.isEmailExistsVerified = true;
        }
      }
    },
    verifyEmail () {
      if (this.user.email && isEmailValid(this.user.email)) {
        this.isVerifyPhone = false;
        this.isVerifyEmail = true;
      }
    },
    verifyPhone () {
      if (this.user.phone && isPhoneValid(this.user.phone)) {
        this.isVerifyEmail = false;
        this.isVerifyPhone = true;
      }
    },
    async sendCode ($event, resend = false) {
      if (/* !this.isVerifyPhone &&  */!this.isVerifyEmail) {
        return;
      }
      if (resend && !this.canResendCode) {
        return;
      }
      let uri = 'email';
      let payload = {};
      if (this.isVerifyPhone) {
        uri = 'phone';
        payload.phone = this.user.phone;
      } else {
        payload.email = this.user.email;
      }
      this.longError = '';
      this.error = '';
      try {
        if (await guestLogin()) {
          window.getApp.$emit('LoadingText', 'Requesting verification code');
          let { error, data, status } = await request(`Verification/SendVerificationOTP/${uri}`, 'POST', payload, null, null, true);
          if (error) {
            if (error.error && this.isVerifyPhone) {
              this.longError = error.error.code === 21211 ? 'Looke like the phone number you entered isn\'t correct. Please check and try again' : (error.error.message || 'Failed to send verification code, please try again');
            } else {
              this.longError = 'Failed to send verification code, please try again';
            }
            this.cancelVerification();
          } else {
            this.isCodeSent = true;
            this.canResendCode = false;
            this.startTimer();
            setTimeout(() => {
              this.canResendCode = true;
            }, 60000);
            this.verificationId = data.verification;
            if (resend) {
              this.resetInputFields();
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    startTimer () {
      this.timer = 60;
      this.interval = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          this.stopInterval();
        }
      }, 1000);
    },
    stopInterval () {
      clearInterval(this.interval);
    },
    setOTP () {
      let otp = '';
      // Get the values from all input fields
      for (let i = 1; i <= 6; i++) {
        const digitInput = document.getElementById('digit' + i);
        otp += digitInput.value;
      }
      this.otp = otp;
    },
    resetInputFields () {
      for (let i = 1; i <= 6; i++) {
        const digitInput = document.getElementById('digit' + i);
        digitInput.value = '';
      }
      // Focus on the first input field after resetting
      document.getElementById('digit1').focus();
    },
    async submitOTP () {
      this.longError = '';
      if (!this.otp || this.otp.length < 6) {
        this.longError = 'Please enter a valid code';
      } else if (await guestLogin()) {
        let uri = 'email';
        let payload = {
          verification: this.verificationId,
          otp: this.otp
        };
        /* if (this.isVerifyPhone) {
          uri = 'phone';
        } */
        window.getApp.$emit('LoadingText', 'Verifying the code');
        let { error, data, status } = await request(`Verification/VerifyCode/${uri}`, 'POST', payload, null, null, true);
        this.loading = false;
        if (error) {
          this.longError = 'Looks like the verification code you entered wasn\'t correct. Please type in the valid code or click on Resend code to get a new one.';
          // Reset the input fields
          this.resetInputFields();
        } else {
          if (this.isVerifyEmail) {
            this.isEmailVerified = true;
          }/*  else if (this.isVerifyPhone) {
            this.isPhoneVerified = true;
          } */
          this.stopInterval();
          this.cancelVerification();
          this.goNext(null, true);
        }
      }
    },
    focusNext (currentInput) {
      // Get the length of the value in the current input
      const inputValueLength = currentInput.target.value.length;

      // If a digit is entered, focus on the next input field
      if (inputValueLength === 1) {
        const nextInput = currentInput.target.nextElementSibling;
        
        if (nextInput) {
          nextInput.focus();
        }
      } else if (inputValueLength === 0) {
        const previousInput = currentInput.target.previousElementSibling;
        
        if (previousInput) {
          previousInput.focus();
        }
      }
      /* Set otp if last one entered */
      if (currentInput.target.id === 'digit6') {
        this.setOTP();
      }
    },
    cancelVerification () {
      /* this.isVerifyEmail = false;
      this.isVerifyPhone = false; */

      this.isCodeSent = false;
      this.otp = '';
    },
    async lookupAddress () {
      this.longError = '';
      this.error = '';
      if (this.user.address.zip && this.user.address.zip.length >= 5 && await guestLogin()) {
        let payload = {
          'zipcode': this.user.address.zip
        };
        window.getApp.$emit('LoadingText', 'Looking for the address');
        let { error, data } = await request('AddressLookup', 'POST', payload, null, null, true);
        if (error) {
          if (error.error) {
            this.longError = error.error === 'Address Not Found' ? 'Failed to find the address, please enter manually' : 'Invalid Address';
          } else {
            this.longError = 'Invalid Address';
          }
        } else {
          this.cityData.push(data.city);
          this.user.address.city = this.cityData[0];
          this.user.address.country = '5f0af2eb1b61360afbb1aa0c';
          let state = this.filteredStates.find(state => state.code === data.state);
          this.user.address.state = state._id;
        }
      }
    }
  }
};
</script>
<style scoped lang="css">
@import url('https://fonts.googleapis.com/css2?family=Marcellus&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Manrope&display=swap');
#login {
    width: 100%;
    background: #fff;
}
#login .v-input {
  font-size: 15px !important;
}
.line {
    flex-grow: 1;
    border-top: 1px solid #cccccc7d;
}
.join-sub-head {
  font-size: 20px;
  text-align: center;
  color: #535353;
  font-weight: 500;
  margin-bottom: 15px;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/Join.vue